var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fault"},[_c('section',{staticClass:"main"},[_c('div',{staticClass:"top"},[_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-face-sad-tear","size":"8x"}}),_c('span',{staticClass:"title"}),(_vm.errorMsg)?_c('span',[_vm._v(" "+_vm._s(_vm.errorMsg))]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('errors.default')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }